import React, { useEffect, useState, useLayoutEffect } from "react";
import ReactDatePicker from "react-datepicker";
import Loader from "react-spinner-loader";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { GridStack } from "gridstack";
import FamilyAffectedTrendView from "../FamilyAffectedTrendView";

import { getData, postDataWithBody } from "../../../../Services/Services";
import {
  getStateFloodCountData,
  getBlockWiseReport,
  getAffectedBlock,
  getAffectedDistrict,
  getAffectedNagarNigam,
  getAffectedPanchayat,
  getAffectedDrilldownView,
  getCurrStateFloodCountData,
  getCurrBarChartData,
} from "../../../../Services/EndPoints";
import "../DMSDashboard/DmsDashboardNew.css";
import "./StateDashboard.css";
import { useTranslation } from "react-i18next";
import {  MapIcon } from "../../../../Components/IconComponents";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import DashboardCard from "./DashboardCard/DashboardCard";
import { currentCardConfig, dashboardCardConfig } from "./StateDashboardConfig";

import CurrentDashboardCard from "../CurrentDashboardCard/CurrentDashboardCard";
import TabSwitch from "../TabSwitch/TabSwitch";
import { useNavigate } from "react-router-dom";

import FloodDistrictBarChart from "./Charts/FloodDistrictBarChart";
import FloodBlocksTreemap from "./Charts/FloodBlocksTreemap";
import FloodMunicipalityBubble from "./Charts/FloodMunicipalityBubble";
import FloodPanchayatAreaChart from "./Charts/FloodPanchayatAreaChart";
//import { ThemeContext } from "../../../..";

// Temporarily hidden per request — flip to true to bring these back
const SHOW_MUNICIPALITIES_AND_PANCHAYATS = false;

const StateDashboard = () => {
  const handle = useFullScreenHandle();
  const [clickedKey, setClickedKey] = useState("");
  const [cardData, setCardData] = useState(null);
  const [currCardData, setCurrCardData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
 // const { theme } = useContext(ThemeContext);
  const [fromDate, setFromDate] = useState("2025-06-01");
  const [toDate, setToDate] = useState();
  const [horizontalChartTitle, setHorizontalChartTitle] = useState("");
  const [drildownAPIkey, setDrildownAPIkey] = useState("");
  const [drillDownData, setDrillDownData] = useState([]);
  const [trendData, setTrendData] = useState([]);
  const [affectedDistrictData, setAffectedDistrictData] = useState([]);
  const [affectedBlockData, setAffectedBlockData] = useState([]);
  const [affectedNagarNigamData, setAffectedNagarNigamData] = useState([]);
  const [affectedPanchayatData, setAffectedPanchayatData] = useState([]);
  const [activeTab, setActiveTab] = useState("dss");
 // const [activeTabBmsk, setActiveTabBmsk] = useState("BMSK");
  const [activeKeyName, setactiveKeyName] = useState("");
  const [apiKeyName, setApiKeyName] = useState({});
  const [error, setError] = useState(false);
  const [selectedYear, setSelectedYear] = useState(2026);

  const { t } = useTranslation();
  const navigate = useNavigate();

  // const handleFromDateChange = (date) => {
  //   if (toDate && date > toDate) {
  //     setError(true);
  //     setFromDate(date);
  //   } else {
  //     setError(false);
  //     setFromDate(date);
  //   }
  // };

  // const handleToDateChange = (date) => {
  //   if (fromDate && date < fromDate) {
  //     setError(true);
  //     setToDate(date);
  //   } else {
  //     setError(false);
  //     setToDate(date);
  //   }
  // };

  const aggregateData = (data) => {
    const aggregatedData = data.reduce((acc, current) => {
      const key = `${current.reported_on_date}-${current.name}-${current.id}`;
      if (!acc[key]) {
        acc[key] = {
          reported_on_date: current.reported_on_date,
          name: current.name,
          count: current.count,
          id: current.id,
          blk_name: [current.blk_name],
        };
      } else {
        acc[key].count += current.count;
        acc[key].blk_name.push(current.blk_name);
      }
      return acc;
    }, {});

    return Object.values(aggregatedData).map((item) => ({
      ...item,
      blk_name: item.blk_name.join(", "),
    }));
  };

  const navigateToGisManagement = () => {
    navigate("/situation-awareness");
  };

  const refreshCardDetailHoriChart = async (title, apiKey, key, apiKey2, keyName) => {
    setApiKeyName({ apiKey, apiKey2, keyName, key });
    setHorizontalChartTitle(title);
    setDrildownAPIkey(key);
    let startDateStr = moment(fromDate).format("YYYY-MM-DD");
    let endDateStr = moment(toDate).format("YYYY-MM-DD");
    let data = [];
    let data2 = [];

    if (activeTab === "dss") {
      data = await getData(
        getAffectedDrilldownView
          .replace("API_KEY", apiKey)
          .replace("FROMDATE", startDateStr)
          .replace("TODATE", endDateStr)
      );
      data2 = await postDataWithBody(
        getCurrBarChartData + apiKey2,
        { fromDate: startDateStr, toDate: endDateStr },
        {}
      );
      setactiveKeyName(keyName);
    } else {
      data = await postDataWithBody(
        getCurrBarChartData + apiKey,
        { fromDate: startDateStr, toDate: endDateStr },
        {}
      );
      if (apiKey2) {
        data2 = await postDataWithBody(
          getCurrBarChartData + apiKey2,
          { fromDate: startDateStr, toDate: endDateStr },
          {}
        );
      }
      setactiveKeyName(keyName);
    }

    let customizedList = [
      "motor_boat", "private_boat", "government_boat", "dry_ration",
      "families_gr_distributed", "food_packets", "polythene_sheets",
      "health_centre", "community_kitchen",
    ];

    if (customizedList.indexOf(key) > -1) {
      if (data && data.length > 0) {
        for (let dataElem in data) {
          data[dataElem]["count"] = data[dataElem][key];
        }
      } else {
        data = [];
      }
    }

    const filtered = data.filter((item) => item.count > 0);

    if (data2?.length > 0 && keyName) {
      const updatedData2 = data2
        .map((item) => ({ ...item, count: item[keyName] }))
        .filter((item) => item.count > 0);
      const result = aggregateData(updatedData2);
      setTrendData(result);
    } else if (data2?.length > 0) {
      const filtered2 = data2.filter((item) => item?.count > 0);
      const result = aggregateData(filtered2);
      setTrendData(result);
    } else {
      const fallbackTrendData = filtered.map((item, index) => ({
        reported_on_date: endDateStr,
        name: item.dist_name || item.name || "Unknown",
        count: item.count || 0,
        id: item.dist_id || item.id || index.toString(),
        blk_name: item.blk_name || ""
      }));
      setTrendData(fallbackTrendData);
    }
    setDrillDownData(filtered);
  };

  const refreshDashboard = async (startDateStr, endDateStr) => {
    startDateStr = moment(startDateStr).format("YYYY-MM-DD");
    endDateStr = moment(endDateStr).format("YYYY-MM-DD");
    setLoader(true);

    var data = await getData(
      getStateFloodCountData
        .replace("FROMDATE", startDateStr)
        .replace("TODATE", endDateStr)
    );
    setCardData(data[0]);
    data = data[0];
    if (data?.families_gr_distributed) {
      data.families_gr_distributed = `${Math.round(data.families_gr_distributed / 7000)}`;
    }

    data = await postDataWithBody(getCurrStateFloodCountData, {}, {});
    setCurrCardData(data[0]);

    let blockdata = [];
    data = await getData(
      getBlockWiseReport
        .replace("FROMDATE", startDateStr)
        .replace("TODATE", endDateStr)
    );
    data.forEach(function (data, index) {
      blockdata.push([data.count_date, data.block_count]);
    });

    data = await getData(getAffectedBlock.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedBlockData(data);

    data = await getData(getAffectedDistrict.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedDistrictData(data);

    data = await getData(getAffectedNagarNigam.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedNagarNigamData(data);

    data = await getData(getAffectedPanchayat.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedPanchayatData(data);

    setLoader(false);
  };

  const refreshDashboardBtnClick = async () => {
    let startDateStr = moment(fromDate).format("YYYY-MM-DD");
    let endDateStr = moment(toDate).format("YYYY-MM-DD");
    setLoader(true);

    var data = await getData(
      getStateFloodCountData
        .replace("FROMDATE", startDateStr)
        .replace("TODATE", endDateStr)
    );
    setCardData(data[0]);
    data = data[0];
    data.families_gr_distributed = `${Math.round(data.families_gr_distributed / 7000)}`;

    data = await postDataWithBody(getCurrStateFloodCountData, {}, {});
    setCurrCardData(data[0]);

    if (activeTab === "dss") {
      let data = await getData(
        getAffectedDrilldownView
          .replace("API_KEY", apiKeyName.apiKey)
          .replace("FROMDATE", startDateStr)
          .replace("TODATE", endDateStr)
      );
      let data2 = await postDataWithBody(
        getCurrBarChartData + apiKeyName.apiKey2,
        { fromDate: startDateStr, toDate: endDateStr },
        {}
      );

      let customizedList = [
        "motor_boat", "private_boat", "government_boat", "dry_ration",
        "families_gr_distributed", "food_packets", "polythene_sheets",
        "health_centre", "community_kitchen", "people_remaining_in_camps", "animal_shelter",
      ];

      if (customizedList.indexOf(apiKeyName.key) > -1) {
        if (data && data.length > 0) {
          for (let dataElem in data) {
            data[dataElem]["count"] = data[dataElem][apiKeyName.key];
          }
        } else {
          data = [];
        }
      }

      const filtered = data.filter((item) => item.count > 0);

      if (data2?.length > 0 && apiKeyName.keyName) {
        const updatedData2 = data2
          .map((item) => ({ ...item, count: item[apiKeyName.keyName] }))
          .filter((item) => item.count > 0);
        const result = aggregateData(updatedData2);
        setTrendData(result);
      } else if (data2?.length > 0) {
        const filtered2 = data2.filter((item) => item?.count > 0);
        const result = aggregateData(filtered2);
        setTrendData(result);
      } else {
        const fallbackTrendData = filtered.map((item, index) => ({
          reported_on_date: endDateStr,
          name: item.dist_name || item.name || "Unknown",
          count: item.count || 0,
          id: item.dist_id || item.id || index.toString(),
          blk_name: item.blk_name || ""
        }));
        setTrendData(fallbackTrendData);
      }
      setDrillDownData(filtered);
    }

    let blockdata = [];
    data = await getData(
      getBlockWiseReport
        .replace("FROMDATE", startDateStr)
        .replace("TODATE", endDateStr)
    );
    data.forEach(function (data, index) {
      blockdata.push([data.count_date, data.block_count]);
    });

    data = await getData(getAffectedBlock.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedBlockData(data);

    data = await getData(getAffectedDistrict.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedDistrictData(data);

    data = await getData(getAffectedNagarNigam.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedNagarNigamData(data);

    data = await getData(getAffectedPanchayat.replace("FROMDATE", startDateStr).replace("TODATE", endDateStr));
    setAffectedPanchayatData(data);

    setLoader(false);
  };

  function getTrendChart() {
    return (
      <FamilyAffectedTrendView
        startDateStr={moment(fromDate).format("YYYY-MM-DD")}
        endDateStr={moment(toDate).format("YYYY-MM-DD")}
        chartData={trendData}
        drillDownKey={drildownAPIkey}
        data={drillDownData}
        title={horizontalChartTitle}
        activeTab={activeTab}
        activeKeyName={activeKeyName}
      />
    );
  }

  const dssDefaultApiCallWithDates = async (startDate, endDate) => {
    let formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    let formattedEndDate = moment(endDate).format("YYYY-MM-DD");
    setDrildownAPIkey("population_affected");
    setApiKeyName({ apiKey: "getPopAffectedDetails", apiKey2: "trnd_population_affected" });

    const data = await getData(
      getAffectedDrilldownView
        .replace("API_KEY", "getPopAffectedDetails")
        .replace("FROMDATE", formattedStartDate)
        .replace("TODATE", formattedEndDate)
    );
    const data2 = await postDataWithBody(
      getCurrBarChartData + "trnd_population_affected",
      { fromDate: formattedStartDate, toDate: formattedEndDate },
      {}
    );
    const filtered = data?.filter((item) => item.count > 0);
    const filtered2 = data2?.filter((item) => item.count > 0);
    setDrillDownData(filtered);
    setTrendData(filtered2);
  };

  const currDefaultApiCall = async () => {
    let startDateStr = moment(fromDate).format("YYYY-MM-DD");
    let endDateStr = moment(toDate).format("YYYY-MM-DD");
    setApiKeyName({ apiKey: "curr_fs_blocks_affected", apiKey2: "" });
    setDrildownAPIkey("curr_dss_affected_blocks");
    const data = await postDataWithBody(
      getCurrBarChartData + "curr_fs_blocks_affected",
      { fromDate: startDateStr, toDate: endDateStr },
      {}
    );
    const filtered = data?.filter((item) => item?.count > 0);
    setDrillDownData(filtered);
    setTrendData([]);
  };

  useEffect(() => {
    if (activeTab === "dss") {
      const currentYear = selectedYear || new Date().getFullYear();
      const today = new Date();
      const newFromDate = new Date(currentYear, 0, 1);
      const dec31OfSelectedYear = new Date(currentYear, 11, 31);
      let newToDate;
      if (currentYear === today.getFullYear()) {
        newToDate = today <= dec31OfSelectedYear ? today : dec31OfSelectedYear;
      } else {
        newToDate = dec31OfSelectedYear;
      }
      setFromDate(newFromDate);
      setToDate(newToDate);
      setClickedKey("population_affected");
      setHorizontalChartTitle("Population Affected");
      dssDefaultApiCallWithDates(newFromDate, newToDate);
      refreshDashboard(newFromDate, newToDate);
    } else if (activeTab === "currentStatus") {
      setClickedKey("curr_dss_affected_blocks");
      currDefaultApiCall();
      setHorizontalChartTitle("Affected Blocks");
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      setFromDate(yesterday);
      setToDate(yesterday);
      refreshDashboard(yesterday, yesterday);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, selectedYear]);

  const toggleFullscreen = () => {
    if (isFullscreen) {
      handle.exit();
    } else {
      handle.enter();
    }
    setIsFullscreen(!isFullscreen);
  };

  const girdoptions = { staticGrid: true, column: 24, margin: 5 };

  useLayoutEffect(() => {
    var grid = GridStack.init(girdoptions);
    console.log("grid",grid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleYearSelection = (selectedList) => {
    if (selectedList.length > 0) {
      const year = parseInt(selectedList[0].name, 10);
      setSelectedYear(year);
      const newFromDate = new Date(year, 0, 1);
      const today = new Date();
      const currentYear = today.getFullYear();
      let newToDate;
      if (year === currentYear) {
        const dec31OfSelectedYear = new Date(year, 11, 31);
        newToDate = today <= dec31OfSelectedYear ? today : dec31OfSelectedYear;
      } else {
        newToDate = new Date(year, 11, 31);
      }
      setFromDate(newFromDate);
      setToDate(newToDate);
    }
  };

  useEffect(() => {
    const year = 2026;
    setSelectedYear(year);
    const jan1 = new Date(year, 0, 1);
    setFromDate(jan1);
    const today = new Date();
    const dec31 = new Date(year, 11, 31);
    const to = today <= dec31 ? today : dec31;
    setToDate(to);
    dssDefaultApiCallWithDates(jan1, to);
    refreshDashboard(jan1, to);
  }, []);
  const ReadOnlyDateInput = React.forwardRef((props, ref) => (
  <input {...props} ref={ref} onKeyDown={e => e.preventDefault()} readOnly />
));

  useEffect(() => {
    if (fromDate && toDate && fromDate > toDate) {
      setError("Select proper From Date and To Date");
    } else {
      setError(null);
    }
  }, [fromDate, toDate]);

  return (
    <FullScreen handle={handle}>
      <div
        className={isFullscreen ? "dms-dashboard fullscreen" : "dms-dashboard"}
        style={{
          height: isFullscreen ? "100vh" : "auto",
          overflow: isFullscreen ? "auto" : "initial",
        }}
      >
        <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

        <div className="container-fluid">

          {/* ── TOP BAR ── */}
          <div className="dms-toprow">

            {/* Title — single line */}
            <div className="dms-title">
              Flood Dashboard
            </div>

            {/* Cumulative / Current toggle */}
            <TabSwitch setActiveTab={setActiveTab} activeTab={activeTab} />

            {/* Year selector — only on DSS tab */}
            {activeTab === "dss" && (
              <div style={{ display: "flex", alignItems: "center", gap: "5px", flexShrink: 0 }}>
                <span className="dms-dr-label">Year</span>
                <select
                  id="entryType"
                  className="custom-dropdown"
                  style={{
                    width: "72px",
                    border: "none",
                    outline: "none",
                    backgroundColor: "rgba(255,255,255,0.12)",
                    color: "white",
                    padding: "3px 6px",
                    borderRadius: "6px",
                    fontSize: "0.78rem",
                  }}
                  value={selectedYear || ""}
                  onChange={(e) => handleYearSelection([{ name: e.target.value }])}
                >
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
            )}

            {/* Date range */}
            <div className="dms-daterange">
              <div className="dms-daterange-field">
                <span className="dms-dr-label">{t("flooddisaster.datetxtfrom")}</span>
                <ReactDatePicker
                  selected={fromDate}
                  onChange={setFromDate}
                  dateFormat="dd/MM/yyyy"
                  isClearable
                  disabled={activeTab === "currentStatus"}
                  minDate={new Date(selectedYear, 0, 1)}
                  maxDate={new Date(selectedYear, 11, 31)}
                  placeholderText={t("flooddisaster.dateplaceholder")}
                  className="dms-dp-input"
                  todayButton="Today"
                  portalId="root-portal"
                  onTodayButtonClick={() => {
                    const today = new Date();
                    const minDate = new Date(selectedYear, 0, 1);
                    const maxDate = new Date(selectedYear, 11, 31);
                    if (today >= minDate && today <= maxDate) {
                      setFromDate(today);
                    } else {
                      setFromDate(minDate);
                    }
                  }}
                  customInput={<ReadOnlyDateInput />}
                />
              </div>

              <div className="dms-dr-divider" />

              <div className="dms-daterange-field">
                <span className="dms-dr-label">{t("flooddisaster.datetxtto")}</span>
                <ReactDatePicker
                  selected={toDate}
                  onChange={setToDate}
                  dateFormat="dd/MM/yyyy"
                  portalId="root-portal"
                  minDate={fromDate || new Date(selectedYear, 0, 1)}
                  maxDate={(() => {
                    const today = new Date();
                    const currentYear = today.getFullYear();
                    const dec31OfSelectedYear = new Date(selectedYear, 11, 31);
                    if (selectedYear === currentYear) {
                      return today <= dec31OfSelectedYear ? today : dec31OfSelectedYear;
                    } else {
                      return dec31OfSelectedYear;
                    }
                  })()}
                  isClearable
                  disabled={activeTab === "currentStatus"}
                  placeholderText={t("flooddisaster.dateplaceholder")}
                  className="dms-dp-input"
                  todayButton="Today"
                  onTodayButtonClick={() => {
                    const today = new Date();
                    const currentYear = today.getFullYear();
                    const dec31OfSelectedYear = new Date(selectedYear, 11, 31);
                    if (selectedYear === currentYear) {
                      setToDate(today <= dec31OfSelectedYear ? today : dec31OfSelectedYear);
                    } else {
                      setToDate(dec31OfSelectedYear);
                    }
                  }}
                  customInput={<ReadOnlyDateInput />}
                />
              </div>
            </div>

            {/* Apply button — only on DSS tab */}
            {activeTab === "dss" && (
              <div className="dms-apply-btn">
                <button onClick={refreshDashboardBtnClick} disabled={!!error}>
                  {t("flooddisaster.apply")}
                </button>
              </div>
            )}

            {/* Form 1-Status + GIS buttons */}
            <div className="dms-apply-btn" style={{ display: "flex", gap: "4px" }}>
              <button
                onClick={() => navigate("/reports/reporting-status")}
                style={{ backgroundColor: "#51A3EE", color: "white" }}
              >
                Form 1-Status
              </button>
              <button
                onClick={navigateToGisManagement}
                title={t("flooddisaster.gis_nav_btn_lbl")}
                style={{
                  backgroundColor: "#082743",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 6px",
                }}
              >
                <MapIcon style={{ marginTop: "-2px" }} />
              </button>
            </div>

            {/* Fullscreen toggle */}
            <div className="dms-btn-icon" onClick={toggleFullscreen}>
              {isFullscreen ? (
                <svg viewBox="0 0 18 18" fill="none" width="14" height="14">
                  <path d="M2 6H6V2M16 6H12V2M2 12H6V16M16 12H12V16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              ) : (
                <svg viewBox="0 0 18 18" fill="none" width="14" height="14">
                  <path d="M2 6V2h4M12 2h4v4M2 12v4h4M16 12v4h-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              )}
            </div>
          </div>

          {/* Error message */}
          {error && <div className="dms-error-msg">{error}</div>}

          {/* ── CARDS ROW ── */}
          {activeTab === "dss" ? (
            <div className="dashboard_card-container mt-2">
              {dashboardCardConfig?.map((card, index) => (
                <DashboardCard
                  key={index}
                  config={card}
                  clickedKey={clickedKey}
                  setClickedKey={setClickedKey}
                  data={cardData}
                  triggeredFunction={refreshCardDetailHoriChart}
                />
              ))}
            </div>
          ) : (
            <div className="d-flex flex-row gap-2 mt-2" style={{ alignItems: "stretch" }}>
              <div 
                className="d-flex flex-column" 
                style={{ 
                  flex: 1, 
                  background: "white",
                  borderRadius: "12px",
                  padding: "0.75rem 1rem",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                  border: "1px solid rgba(0, 0, 0, 0.05)",
                  gap: "1rem"
                }}
              >
                {currentCardConfig?.map((card, index) => (
                  <CurrentDashboardCard
                    key={index}
                    config={card}
                    clickedKey={clickedKey}
                    setClickedKey={setClickedKey}
                    data={currCardData}
                    triggeredFunction={refreshCardDetailHoriChart}
                  />
                ))}
              </div>
              <div style={{ flex: 1 }}>
                {getTrendChart()}
              </div>
            </div>
          )}

          {/* ── MAIN CHART LAYOUT (DSS only) ── */}
          {activeTab === "dss" && (
            <div className="flood-dashboard-main-layout mt-1 mb-4">
              <div className="flood-trend-section">
                {getTrendChart()}
              </div>
              <div className="flood-charts-grid">
                <FloodDistrictBarChart
                  title={"AFFECTED DISTRICTS"}
                  dataval={affectedDistrictData}
                  startDateStr={moment(fromDate).format("YYYY-MM-DD")}
                  endDateStr={moment(toDate).format("YYYY-MM-DD")}
                />
                <FloodBlocksTreemap
                  title={"AFFECTED BLOCKS"}
                  dataval={affectedBlockData}
                  startDateStr={moment(fromDate).format("YYYY-MM-DD")}
                  endDateStr={moment(toDate).format("YYYY-MM-DD")}
                />
                {SHOW_MUNICIPALITIES_AND_PANCHAYATS && (
                  <>
                    <FloodMunicipalityBubble
                      title={"AFFECTED MUNICIPALITIES"}
                      dataval={affectedNagarNigamData}
                      startDateStr={moment(fromDate).format("YYYY-MM-DD")}
                      endDateStr={moment(toDate).format("YYYY-MM-DD")}
                    />
                    <FloodPanchayatAreaChart
                      title={"AFFECTED PANCHAYATS"}
                      dataval={affectedPanchayatData}
                      startDateStr={moment(fromDate).format("YYYY-MM-DD")}
                      endDateStr={moment(toDate).format("YYYY-MM-DD")}
                    />
                  </>
                )}
              </div>
            </div>
          )}

        </div>
      </div>
    </FullScreen>
  );
};

export default StateDashboard;